module.exports = __webpack_public_path__ + "img/cloud.6fd612a2.png";